<template>
  <div class="user-create">
    <h1 class="center-text">Create User</h1>
    <form @submit.prevent="createUserAdditional">
      <div v-if="apiError" class="error center-element">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div v-if="isError" class="error center-element">
        Error with form<br />
      </div>
      <div class="form-300 center-element">
        <label>Full Name</label><br />
        <input
          v-model.trim="user.full_name"
          type="text"
          placeholder="User Full Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'User Full Name'"
          required
        /><br />
        <label>Email</label><br />
        <input
          v-model.trim="user.email"
          type="text"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <div v-if="isEmailError" class="error">
          {{ errorEmailMessage }}<br />
        </div>
        <button type="submit" class="button button-300">Create User</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
import router from "@/router";
const apiServiceUser = new api.APIServiceUser();

export default {
  data() {
    return {
      user: {
        full_name: "",
        email: ""
      },
      isError: false,
      isEmailError: false,
      errorEmailMessage: "",
      apiError: false,
      apiErrorMessage: ""
    };
  },
  created() {
    this.isError = false;
  },
  methods: {
    createUserAdditional: function() {
      this.isError = false;
      this.isEmailError = false;
      let reEmailFormat = /^[^@|^\s]+@\S+\.\S+/;
      let resultEmailFormat = reEmailFormat.test(this.user.email);
      if (!resultEmailFormat) {
        this.isError = true;
        this.isEmailError = true;
        this.errorEmailMessage = "Invalid email entered";
      }
      if (!this.isError) {
        apiServiceUser
          .createUserAdditional(this.user)
          .then(data => {
            router.push("/console/dashboard/users");
          })
          .catch(error => {
            this.apiError = true;
            this.apiErrorMessage = error;
          });
      }
    }
  }
};
</script>
